import React, { Fragment, useMemo, useState } from "react";
import { format } from "date-fns";
import { Modal } from "antd";
import { Permissions } from "../../Constantes/permissions.constants";
import { Message } from "../../Constantes/message.constants";
import { Secured } from "../../component";
import config from "../../config";
import Table, {
    AlignType,
    TypeFilter,
    TypeOperator,
} from "../../component/Table";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const MASK_NUMBER = (limitInteger = null) => {
    return createNumberMask({
        prefix: "",
        includeThousandsSeparator: false,
        allowDecimal: false,
        integerLimit: limitInteger,
        allowNegative: false,
        allowLeadingZeroes: true,
        requireDecimal: false,
    });
};

const removeMask = (value) => {
    return value !== "" && value !== undefined && value !== null
        ? String(value).replace(/[^0-9]/g, "")
        : value;
};

const applyMaskDataHora = (dataString) => {
    if (!dataString) {
        return "";
    }

    let value = removeMask(dataString);
    const mask = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;

    value =
        value.length > 14
            ? value.substring(0, 14).replace(mask, "$3/$2/$1 $4:$5:$6")
            : value.replace(mask, "$3/$2/$1 $4:$5:$6");

    return value;
};

const formatarData = (data) => {
    if (!data) {
        return "";
    }

    try {
        return format(data, "yyyy-MM-dd HH:mm:ss");
    } catch (error) {
        return data;
    }
};

const PainelLocal = ({ titulo, children }) => {
    return (
        <div className="card mb-3">
            {titulo && (
                <div className="card-header">
                    <h4 className="mb-0">{titulo}</h4>
                </div>
            )}
            <div className="card-body">{children}</div>
        </div>
    );
};

const AdministracaoAuditoria = () => {
    const [openModal, setOpenModal] = useState(false);
    const [dados, setDados] = useState({});

    const detalhe = (event, item) => {
        if (event) {
            event.preventDefault();
        }

        setOpenModal(true);
        setDados(item);
    };

    const closeModal = () => {
        setOpenModal(false);
        setDados({});
    };

    const columns = useMemo(() => {
        return [
            {
                Header: "Data e Hora",
                accessor: "data",
                Cell: ({ value }) => applyMaskDataHora(value),
                filter: {
                    tipo: TypeFilter.DATE,
                    nome: "Data e Hora",
                    operator: TypeOperator.ENTRE,
                    field: "data",
                    isTime: true,
                    valueFilterApi: formatarData,
                },
                alignItems: AlignType.CENTER,
            },
            {
                Header: "Transação",
                accessor: "transacao",
                filter: {
                    tipo: TypeFilter.TEXT,
                    nome: "Transação",
                    operator: TypeOperator.CONTEM,
                    field: "transacao",
                },
                alignItems: AlignType.CENTER,
            },
            {
                Header: "Usuário",
                accessor: "usuario",
                filter: {
                    tipo: TypeFilter.TEXT,
                    nome: "Usuário",
                    operator: TypeOperator.CONTEM,
                    mask: MASK_NUMBER(),
                    field: "usuario",
                },
                alignItems: AlignType.CENTER,
            },
            {
                Header: "Departamento",
                accessor: "departamento",
                filter: {
                    tipo: TypeFilter.TEXT,
                    nome: "Departamento",
                    operator: TypeOperator.CONTEM,
                    field: "departamento",
                },
                alignItems: AlignType.CENTER,
            },
            {
                Header: "Aplicação",
                accessor: "aplicacao",
                filter: {
                    tipo: TypeFilter.TEXT,
                    nome: "Aplicação",
                    operator: TypeOperator.CONTEM,
                    field: "aplicacao",
                },
                alignItems: AlignType.CENTER,
            },
            {
                Header: "Entidade",
                accessor: "entidade",
                filter: {
                    tipo: TypeFilter.TEXT,
                    nome: "Entidade",
                    operator: TypeOperator.CONTEM,
                    field: "entidade",
                },
                alignItems: AlignType.CENTER,
            },
            {
                Header: "Ação",
                accessor: "acao",
                filter: {
                    tipo: TypeFilter.TEXT,
                    nome: "Ação",
                    operator: TypeOperator.CONTEM,
                    field: "acao",
                },
                alignItems: AlignType.CENTER,
            },
            {
                Header: "Detalhe",
                width: "6%",
                accessor: "dados",
                Cell: ({ value }) => (
                    <button
                        type="button"
                        className="btn btn-outline-success btn-sm"
                        title="Detalhe"
                        onClick={(event) => detalhe(event, value)}
                    >
                        <i className="fas fa-list-ul" />
                    </button>
                ),
                disableFilters: true,
                disableSortBy: true,
                alignItems: AlignType.CENTER,
            },
        ];
    }, []);

    return (
        <Fragment>
            <Secured
                hasAllRole={Permissions.ADMINISTRACAO_SISTEMA.AUDITORIA}
                isShowErro403={true}
            >
                <div className="col-12">
                    <PainelLocal titulo="Auditoria">
                        <Table
                            columns={columns}
                            url={`${config.AUDITORIA}auditorias/filter`}
                            isPaginationMemory={false}
                            isFilterTable={false}
                            selectedField={true}
                            isFormFilter={true}
                            filtroLista={{
                                field: "aplicacao",
                                operator: "LK",
                                value: "simulador-api",
                                fieldType: TypeFilter.TEXT,
                            }}
                            isExibePainel={false}
                            message={Message}
                        />
                    </PainelLocal>
                </div>

                <Modal
                    title="Detalhes da Auditoria"
                    open={openModal}
                    onCancel={closeModal}
                    footer={null}
                    width={800}
                >
                    <div className="painel-json">
                        <pre>{JSON.stringify(dados, null, 2)}</pre>
                    </div>
                </Modal>
            </Secured>
        </Fragment>
    );
};

export default AdministracaoAuditoria;
